// extracted by mini-css-extract-plugin
export default {"footerArea":"Footer_footerArea__7iXgh","nav":"Footer_nav__FiETB","navLink":"Footer_navLink__ud3W9"};